import { render, staticRenderFns } from "./carrier-create.vue?vue&type=template&id=a214877a&"
import script from "./carrier-create.vue?vue&type=script&lang=js&"
export * from "./carrier-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports